module.exports = __webpack_public_path__ + "static/media/about-1.ab4ad7da.png";